/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&name=NavMenu&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=NavMenu&lang=js"

import "./index.vue?vue&type=style&index=0&id=39df9259&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39df9259"]])

export default __exports__